import { ColorProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Tag, TagProps } from '../../../atoms';

export type GenericTagVariant = 'success' | 'warning' | 'neutral' | 'alert';

export type GenericTagSize = 'lg' | 'md';

const backgroundColor: { [key in GenericTagVariant]: ColorProps['color'] } = {
  success: 'background.status.default.success',
  warning: 'background.status.default.warning',
  neutral: 'background.surface',
  alert: 'background.status.default.alert'
};

const textColor: { [key in GenericTagVariant]: ColorProps['color'] } = {
  success: 'text.status.onSuccessDefaultContainer',
  warning: 'text.status.onWarningDefaultContainer',
  neutral: 'text.prominent',
  alert: 'text.status.onAlertDefaultContainer'
};

interface GenericStatusTagProps extends TagProps {
  variant: GenericTagVariant;
  size?: GenericTagSize;
}

export function GenericStatusTag({
  variant,
  size = 'lg',
  children
}: GenericStatusTagProps): ReactNode {
  return (
    <Tag
      h={size === 'lg' ? '36px' : '28px'}
      py="space_unit.x1"
      px="space_unit.x2"
      size={size}
      borderRadius="radii.x2"
      backgroundColor={backgroundColor[variant]}
      color={textColor[variant]}
      w="fit-content"
      textStyle={size === 'lg' ? 'bodyLarge' : 'bodyMedium'}
    >
      {children}
    </Tag>
  );
}
